import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';
import { useCallback, useContext, useEffect, useState } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '@/features/account-management/account.navigator';
import { ModalContainerView } from '@/features/account-management/components/ModalContainerView';
import { CardDetailMainNative } from '@/features/account-management/screens/details/CardDetailMainNative';
import { CardDetailDailyLimitTypesNative } from '@/features/account-management/screens/details/CardDetailDailyLimitTypesNative';

import { CardDetailStackParamList, CardDetailStackRoutes } from './type';

const CardDetailStack = createNativeStackNavigator<CardDetailStackParamList>();

export const CardDetailNavigator: React.FC<AccountManagementStackScreenProps<AccountManagementStackRoutes.CardDetail>> = ({ route }) => {
  const {
    account,
    tab,
    record,
    funcLockCard,
    funcUnlockCard,
    funcSetCardLimit,
    funcChangeCardPin,
    refresh,
    funcActivateCard,
    funcCancelCard,
    funcSuspendCard,
    funcUnsuspendCard,
    funcUpdateCardPhoneNumberCard
  } = route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  const [data, setData] = useState(undefined);
  const onData = (data: any) => {
    setData(data);
  };

  return (
    <ModalContainerView dimensions={dimensions} nativeFlag={false}>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <CardDetailStack.Navigator
          initialRouteName={CardDetailStackRoutes.Main}
          screenOptions={{
            presentation: 'transparentModal',
            headerShown: false,
            contentStyle: {
              backgroundColor: 'transparent'
            }
          }}>
          <CardDetailStack.Screen
            name={CardDetailStackRoutes.Main}
            component={CardDetailMainNative}
            initialParams={{
              onLayout,
              record,
              account,
              tab,
              funcLockCard,
              funcUnlockCard,
              funcSetCardLimit,
              funcChangeCardPin,
              refresh,
              funcActivateCard,
              funcCancelCard,
              funcSuspendCard,
              funcUnsuspendCard,
              funcUpdateCardPhoneNumberCard
            }}
            options={{ headerShown: false }}
          />
          <CardDetailStack.Screen
            name={CardDetailStackRoutes.DailyLimitTypes}
            component={CardDetailDailyLimitTypesNative}
            initialParams={{ onLayout }}
            options={{
              presentation: 'transparentModal',
              headerShown: false,
              contentStyle: {
                backgroundColor: 'transparent'
              }
            }}
          />
        </CardDetailStack.Navigator>
      </View>
    </ModalContainerView>
  );
};
